/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */

import { createAction } from '../app/createAction';
import {
    CHANGE_CAPTCHA_VALUE,
    HIDE_CAPTCHA,
    REQUEST_CAPTCHA,
    REQUEST_CAPTCHA_FAILED,
    SET_IMAGE_CAPTCHA,
    SHOW_CAPTCHA,
} from './captchaConstants';

export interface ICaptchaAction {
    type: string;
    payload?: IChangeCaptchaPayload;
}

export interface IChangeCaptchaPayload {
    value?: string;
    captchaImage?: string;
    captchaTime?: number;
}

export const showCaptcha = (): ICaptchaAction =>
    createAction(SHOW_CAPTCHA);

export const requestCaptcha = (payload: IChangeCaptchaPayload): ICaptchaAction =>
    createAction(REQUEST_CAPTCHA, payload);

export const setImageCaptcha = (payload: IChangeCaptchaPayload): ICaptchaAction =>
    createAction(SET_IMAGE_CAPTCHA, payload);

export const changeCaptchaValue = (payload: IChangeCaptchaPayload): ICaptchaAction =>
    createAction(CHANGE_CAPTCHA_VALUE, payload);

export const requestCaptchaFailed = (): ICaptchaAction =>
    createAction(REQUEST_CAPTCHA_FAILED);

export const hideCaptcha = (): ICaptchaAction =>
    createAction(HIDE_CAPTCHA);
